import moment from 'moment-jalaali'

const faNums = "۰۱۲۳۴۵۶۷۸۹"
const enNums = "0123456789"

const oneDay = 24 * 3600 * 1000
const dayOfWeek = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه']

export function jMoment(...args) {
    moment.loadPersian({
        usePersianDigits: true,
        dialect: 'persian-modern'
    })

    return moment(...args)
}

export function formatNumberToPersian(str) {
    if (!str && str !== 0) return ""

    str = str.toString()
    for (let i = 0; i < 10; i++) {
        let replaceEntoFa = new RegExp("" + i, "g")
        str = str.toString().replace(replaceEntoFa, faNums[i])
    }

    return str
}

export function formatNumberToEnglish(str) {
    if (!str && str !== 0) return ""

    str = str.toString()
    for (let i = 0; i < 10; i++) {
        let replaceEntoEn = new RegExp("" + faNums[i], "g")
        str = str.toString().replace(replaceEntoEn, enNums[i])
    }

    return str
}

export function getAfterDay(i) {
    let date = new Date();
    return dayOfWeek[((date.getDay() + i) + 1) % 7]
}

export function getTimeString(timestamp) {
    if (!timestamp) {
        return 'NaN'
    }
    let date = new Date(timestamp);
    let now = new Date()

    let dayOfDate = Math.floor(date.getTime() / oneDay)
    let dayOfNow = Math.floor(now.getTime() / oneDay)

    if (dayOfDate === dayOfNow)
        return 'امروز'
    else if (dayOfDate === dayOfNow + 1)
        return '‌فردا'
    else if (dayOfDate === dayOfNow + 2)
        return 'پس‌فردا'
    else if (dayOfDate === dayOfNow - 1)
        return 'دیروز'

    let jDate = jMoment(timestamp)
    let jNow = jMoment()

    if (jDate.jYear() === jNow.jYear())
        return jDate.format('jDD jMMMM')

    return jDate.format('jYYYY/jMM/jDD')
}

export function runAfterLoadSession(func) {
    if (window.sessionLoaded && window.userLogin) {
        func()
    } else if (window.sessionLoaded && !window.userLogin) {
        return
    } else if (!window.sessionLoaded) {
        setTimeout(() => {
            runAfterLoadSession(func)
        }, 300)
    }
}

export function formatToToamn(price, withoutToman) {
    let result = ''
    price = (Math.round(price/ 10) ).toString()
    let counter = 1;
    for (let i = price.length - 1; i >= 0; --i) {
        result = (counter % 3 === 0 && i !== 0 ? ',' : '') + price.charAt(i) + result
        counter++
    }
    return formatNumberToPersian(result) + (withoutToman !== undefined && withoutToman ? '' : ' تومان')
}

export function isIos() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
}

export function isAndroid() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android/.test(userAgent);
}

export function isInStandaloneMode() {
    return (('standalone' in window.navigator) && (window.navigator.standalone)) || (window.matchMedia('(display-mode: standalone)').matches);
}

export function getCompleteTime(time) {
    return formatNumberToPersian((time < 10 ? '0' + time : time) + ":00")
}

export function summarizeString(str, size) {
    if (str.length >= (size ? size + 3 : 20))
        return str.substring(0, (size ? size : 20)) + "...";
    return str;
}

export function formatToDollar(numberInCent,withoutDollarSign) {
    let cents = numberInCent%100
    return (withoutDollarSign ? "" : "$") + Math.floor(numberInCent/100) + "." + (cents < 10 ? "0" + cents : cents)
}

function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

export function formatDate(date) {
    return (
        [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
        ].join('-') +
        ' ' +
        [
            padTo2Digits(date.getHours()),
            padTo2Digits(date.getMinutes()),
        ].join(':')
    );
}
